<template>
  <div class="flex">
    <div>
      <v-alert type="success" v-if="asignated">
        Equipo asignado exitosamente</v-alert
      >
    </div>
    <div>
      <v-alert type="error" v-if="errorAsignated">
        No se ha podido cargar .
      </v-alert>
    </div>
    <div class="justify-center">
      <v-container>
        <v-row class="flex-column">
          <v-card>
            <v-card-title>
              <span class="text-h5">Asignar Equipos</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                      :items="empresas"
                      v-model="empresa"
                      label="Empresa"
                      :value="selectedEmpresa"
                      dense
                      @change="onEmpresaSelected"
                    ></v-select>                   
                    <router-list
                      :routersLibres="routersLibres"
                      :selectedRouterId="selectedRouterId"
                      @routerSelected="onRouterSelected"
                    />
                    <!-- </v-select> -->
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <p>
                      Cantidad de equipos disponibles:{{
                        filteredRouters.length
                      }}
                    </p>
                    <div
                      v-for="(count, empresa) in filteredRoutersByCompany"
                      :key="empresa"
                    >
                      {{ empresa }}: {{ count }}
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="asignar">Asignar</v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
        <v-row> </v-row>
        <DataRouter
          :router="routerSeleccionado"
          :empresa="selectedEmpresa"
          @cerrar="closeModal"
          @success="succesAlert"
          @error="errorAlert"
          @asignated="deleteRouter"
          v-if="showModalFlag"
        ></DataRouter>
      </v-container> 
      <RouterTable
        v-if="tablevisible"
        :empresa="selectedEmpresa"
        :tecnico="filteredUser"
      ></RouterTable>
    </div>
  </div>
</template>
<script>
// import EquipoStore from "../store/index";
import { mapState, mapGetters, mapActions } from "vuex";
import DataRouter from "@/components/DataRouter";
import RouterTable from "@/components/RouterTable";
import RouterList from "@/components/RouterList";
import {
  getAllBitway,
  // // addBitway,
  // updateBitway,
  // updateOptix,
  // updateWestnet,
  // deleteBitway,
  // // updateArray,
   getAllOptix,
  getAllWestnet,
  // // deleteArray,
} from "../database.js";
// import { addRouters } from "../database.js";

export default {
  name: "EquiposTecnicos",

  components: {
    DataRouter,
    RouterTable,
    RouterList,
  },
  data() {
    return {
      asignated: false,
      errorAsignated: false,
      selected: null,
      selectedRouterId: null,
      visible: false,
      tablevisible: false,
      tecnico: "",
      empresa: "",
      routersDisponibles: [],
      routerSeleccionado: null,
      selectedEmpresa: null,
      selectedRouters: [],
      router: "",
      tecnicoAsignated: false,
      mac: "",
      macAsignados: [],
      namesObject: [],
      conectores: null,
      drops: null,
      items: [
        "Administrador",
        "Técnico Optix",
        "Técnico Westnet",
        "Técnico Bigway",
      ],
      empresas: [
        // { value: "westnet", text: "Westnet" },
        // { value: "optix", text: "Optix" },
        // { value: "bitway", text: "Bigway" },
      ],
      routers: [],
      idusuario: "",
      idusuarioSelected: "",
      date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      ).toLocaleDateString(),
    };
  },
  computed: {
    ...mapGetters(["showModalFlag"]),
    ...mapState({
      users: (state) => state.users,
      userlogged: (state) => state.userLogged,
      optix: (state) => state.optixData,
      westnet: (state) => state.westnetData,
      bigway: (state) => state.bigwayData,
      // idtecnico: (state) => state.idtecnico,
    }),
    routersLibres() {
       
      return this.routersDisponibles.filter(
        (router) => router.estado === "LIBRE"
      );
    },
    filteredUser() {
      return this.users.find((user) => user.email === this.userlogged);
    },
    filteredRouters() {
      const user = this.filteredUser;
      if (user && user.empresa) {
        const empresas = user.empresa;
        let routers = [];
        if (empresas.includes("Optix")) {
          routers = routers.concat(this.optix);
        }
        if (empresas.includes("Westnet")) {
          routers = routers.concat(this.westnet);
        }
        if (empresas.includes("Bigway")) {
          routers = routers.concat(this.bigway);
        }
        const filteredRouters = routers.filter(
          (router) =>
            router.asignado === user.nombre && router.estado === "LIBRE"
        );
        return filteredRouters;
      }
      return {};
    },
    filteredRoutersByCompany() {
      const user = this.filteredUser;
      if (user && user.empresa) {
        const empresas = user.empresa;
        const routerCounts = {};
        empresas.forEach((empresa) => {
          let routersInEmpresa = [];
          if (empresa === "Optix") {
            routersInEmpresa = this.optix.filter(
              (router) =>
                router.asignado === user.nombre && router.estado === "LIBRE"
            );
          }
          if (empresa === "Westnet") {
            routersInEmpresa = this.westnet.filter(
              (router) =>
                router.asignado === user.nombre && router.estado === "LIBRE"
            );
          }
          if (empresa === "Bigway") {
            routersInEmpresa = this.bigway.filter(
              (router) =>
                router.asignado === user.nombre && router.estado === "LIBRE"
            );
          }
          routerCounts[empresa] = routersInEmpresa.length;
        });
        return routerCounts;
      }
      return {};
    },
    filteredRoutersByEmpresa() {
      const empresa = this.selectedEmpresa;
      const user = this.filteredUser;
      if (empresa && user && user.nombre) {
        const empresaData = this.empresas.find((e) => e.nombre === empresa);
        if (empresaData && empresaData.routers) {
          return empresaData.routers.filter(
            (router) =>
              router.num_router &&
              router.asignado === user.nombre &&
              router.estado === "LIBRE"
          );
        }
      }
      return [];
    },
    routersAsignados() {
      const user = this.filteredUser;
      if (user && user.empresa && this.empresaSeleccionada) {
        const empresa = this.empresaSeleccionada;
        const routers = [];
        if (empresa === "Optix") {
          routers.push(...this.optix);
        }
        if (empresa === "Westnet") {
          routers.push(...this.westnet);
        }
        if (empresa === "Bigway") {
          routers.push(...this.bigway);
        }
        return routers.filter(
          (router) =>
            router.asignado === user.nombre &&
            router.empresa === empresa &&
            router.estado === "LIBRE"
        );
      }
      return [];
    },
  },
  created() {
    // this.arrayToObject()
    // console.log("users: ", this.users);
    // console.log("usuario logeado: ", this.userlogged);
    //como hacer para que routerTable no se cargue hasta que se seleccione una empresa del dropdown?
    this.tablevisible = false;
  },
  mounted() {
    const user = this.filteredUser;
    if (user && user.empresa) {
      const empresas = user.empresa;
      const empresasFiltradas = [];
      if (empresas.includes("Optix")) {
        empresasFiltradas.push("Optix");
      }
      if (empresas.includes("Westnet")) {
        empresasFiltradas.push("Westnet");
      }
      if (empresas.includes("Bigway")) {
        empresasFiltradas.push("Bigway");
      }
      this.empresas = empresasFiltradas;
    }
  },
  watch: {
    empresa: function (newEmpresa) {
      const routersInEmpresa = this.routers.filter((router) => {
        return router.num_router.includes(newEmpresa); // O cambiar por la propiedad correcta que relacione el router con la empresa
      });
      this.macs = routersInEmpresa.map((router) => router.mac);
    },
  },
  methods: {
    ...mapActions(["openModal", "closeModal"]),
    asignar() {},

    getFilteredRoutersByCompany() {
      let filteredRouters = [];
      if (this.selectedCompany === "All") {
        filteredRouters = this.routers;
      } else {
        // Convierta el objeto this.filteredRouters en un array antes de aplicar filter()
        filteredRouters = Object.values(this.filteredRouters).filter(
          (router) => router.company === this.selectedCompany
        );
      }
      return filteredRouters;
    },
    onEmpresaSelected() {
      const user = this.filteredUser;
      const empresaRouters = {
        Optix: this.optix.filter((router) => router.asignado === user.nombre),
        Westnet: this.westnet.filter(
          (router) => router.asignado === user.nombre
        ),
        Bigway: this.bigway.filter((router) => router.asignado === user.nombre),
      };
      console.log("empresarouters", empresaRouters);
      this.routersDisponibles = empresaRouters[this.empresa];
      console.log(this.routersDisponibles);
      this.selectedEmpresa = this.empresa;
      this.routerSeleccionado = null;
    },
    onRouterSelected(router) {
      this.selectedRouterId = router.id;
      this.asignated = false;
      this.errorAsignated = false;
      this.routerSeleccionado = router.id;
      // this.visible = true;
      this.openModal(router);
    },
    async succesAlert() {
      if(this.selectedEmpresa=== "Optix"){
         await getAllOptix()
      }
      if(this.selectedEmpresa=== "Westnet"){
        await getAllWestnet()
      }
      if(this.selectedEmpresa=== "Bigway"){
        await getAllBitway()
      }
     
      this.asignated = true;
      this.tablevisible = true;
      this.onEmpresaSelected()

    },
    routersLibres1() {
      return this.routersDisponibles.filter(router => router.estado === "LIBRE");
    },
    errorAlert() {
      this.errorAsignated = true;
    },
    deleteRouter(routerToDelete) {
      console.log(routerToDelete);
      const index = this.routerslibre.indexOf(routerToDelete);
      if (index !== -1) {
        this.routerslibre.splice(index, 1);
      }
    },
  },
};
</script>
